import { MainHeaderProps } from './MainHeader.types'
import { isString } from '../../../utils'
import Heading from '../Heading'
import Logo from '../Logo'
import IconButton from '../IconButton/IconButton'
import {
  MainHeaderSide,
  MainHeaderContent,
  MainHeaderWrapper,
  Subtitle,
  MainHeaderTextContent
} from './MainHeader.styles'
import useId from '../../hooks/useId'

const MainHeader = ({
  heading,
  logo,
  align = 'start',
  back,
  buttons = [],
  styles,
  subtitle,
  subTitleCount,
  subtitleSingular,
  'data-testid': testid = 'main-header',
  ...props
}: MainHeaderProps) => {
  const logoProps = isString(logo) ? { src: logo } : logo
  const headingProps = isString(heading) ? { value: heading } : heading
  const { getTestId } = useId(testid)
  let subTitleContent = subtitle
  if (subtitle && subtitleSingular && subTitleCount && subTitleCount === 1) {
    subTitleContent = subtitleSingular
  }
  const subtitleProps = isString(subTitleContent)
    ? { value: subTitleContent }
    : subTitleContent

  return (
    <MainHeaderWrapper
      className="MainHeader"
      sx={styles}
      data-testid={getTestId()}
      {...props}>
      {(!!back || align === 'center') && (
        <MainHeaderSide className="MainHeaderSideStart">
          {!!back && (
            <IconButton
              icon={back.icon || 'MdOutlineArrowBack'}
              iconset={back.iconset}
              styles={back.styles}
              onClick={back.actions as unknown as React.MouseEventHandler<HTMLButtonElement> }
              data-testid={getTestId('back')}
            />
          )}
        </MainHeaderSide>
      )}
      <MainHeaderContent className="MainHeaderContent" align={align}>
        {!!logoProps?.src && (
          <Logo
            className="Logo"
            data-testid={getTestId('logo')}
            {...logoProps}
          />
        )}
        <MainHeaderTextContent subtitle={subtitle}>
          {!!heading && (
            <Heading
              className="Heading"
              data-testid={getTestId('heading')}
              {...headingProps}
            />
          )}
          {!!subtitle && (
            <Subtitle
              className="Heading"
              data-testid={getTestId('subtitle')}
              {...subtitleProps}
            />
          )}
        </MainHeaderTextContent>
      </MainHeaderContent>
      {(!!buttons.length || align === 'center') && (
        <MainHeaderSide className="MainHeaderSideEnd">
          {buttons.map(
            ({
              icon,
              actions,
              'data-testid': buttonTestid,
              ...buttonProps
            }) => {
              const buttonId = buttonTestid || icon
              return (
                <IconButton
                  key={buttonId}
                  icon={icon}
                  onClick={actions as unknown as React.MouseEventHandler<HTMLButtonElement>}
                  data-testid={getTestId(buttonId)}
                  {...buttonProps}
                />
              )
            }
          )}
        </MainHeaderSide>
      )}
    </MainHeaderWrapper>
  )
}

export default MainHeader
